var v = (r) => {
  throw TypeError(r);
};
var k = (r, t, e) => t.has(r) || v("Cannot " + e);
var i = (r, t, e) => (k(r, t, "read from private field"), e ? e.call(r) : t.get(r)), n = (r, t, e) => t.has(r) ? v("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(r) : t.set(r, e), A = (r, t, e, s) => (k(r, t, "write to private field"), s ? s.call(r, e) : t.set(r, e), e), N = (r, t, e) => (k(r, t, "access private method"), e);
var T, L;
let M = (L = class {
  constructor({
    timeout: t,
    action: e,
    onTimeout: s
  }) {
    n(this, T);
    this.action = e, A(this, T, setTimeout(() => s(e), t));
  }
  ack() {
    clearTimeout(i(this, T));
  }
}, T = new WeakMap(), L);
const D = "ack-action", F = "handle-action", P = "process-action", R = "register-window-for-actions";
var _;
class S {
  constructor({
    timeout: t,
    action: e,
    onTimeout: s
  }) {
    n(this, _);
    this.action = e, A(this, _, setTimeout(() => s(e), t));
  }
  ack() {
    clearTimeout(i(this, _));
  }
}
_ = new WeakMap();
var l, d, p, C, E, f, I, O, m, c, x, H, W;
class U {
  constructor({
    onAck: t,
    actionHandlingTimeout: e = 3e4,
    onTimeout: s,
    onError: h
  }) {
    n(this, c);
    /**
     * A queue of actions per window type
     */
    n(this, l, /* @__PURE__ */ new Map());
    /**
     * Keeps track of all registered window targets for a given type.
     */
    n(this, d, /* @__PURE__ */ new Map());
    /**
     * Each action is wrapped within a wrapper inside the queue to faciliate timeout mechanics.
     * Keep track of the action wrappers is important so that timeouts can be stopped when an
     * action has been acknowledged
     */
    n(this, p, /* @__PURE__ */ new Map());
    /**
     * Callback that is being called when an action is acknowledged
     */
    n(this, C);
    /**
     * Callback that is being called when an action times out
     */
    n(this, E);
    /**
     * Callback that is being called when an error needs to be captured
     */
    n(this, f);
    /**
     * Timeout duration for an action
     */
    n(this, I);
    n(this, O, /* @__PURE__ */ new Map());
    /**
     * Some actions might need to be published to different actions than what their `targetWindowType` dictates.
     * An example would be an `OPEN_EVENT_WINDOW` action which has a target type of `ROOT`. Reason being: this action
     * must actually perform a route change when the app is running in web. In electron this action must be handled
     * in the main thread, but then be sent to the `EVENTS` window. IF the action is subsequently ack'd in web,
     * it'll come back to electron to also be ack'd here. Without this remapping it would try to remove the action from
     * the `ROOT` queue, which doesn't exist, as the action was pushed into the `EVENTS` queue instead.
     */
    n(this, m, /* @__PURE__ */ new Map());
    A(this, C, t), A(this, I, e), A(this, E, s), A(this, f, h);
  }
  /**
   * Adds an action to the queue for the given `targetWindowType`.
   */
  enqueue(t, e) {
    var h;
    i(this, l).has(t) || i(this, l).set(t, []), e.targetWindowType !== t && i(this, m).set(e.id, t), i(this, p).set(
      e.id,
      new M({
        action: e,
        onTimeout: (o) => {
          i(this, p).delete(o.id), N(this, c, x).call(this, o), N(this, c, W).call(this, o), i(this, E).call(this, o);
        },
        timeout: i(this, I)
      })
    ), (h = i(this, l).get(t)) == null || h.push(e);
    const s = i(this, d).get(t);
    s != null && s.length && N(this, c, H).call(this, t, s);
  }
  /**
   * Registers a new window target with the queue. In case actions are
   * pending for this window type, they will all be flushed to the newly registered
   * target. Returns a deregistration function.
   */
  registerWindowTarget(t, e) {
    var s;
    return i(this, d).has(t) || i(this, d).set(t, []), (s = i(this, d).get(t)) == null || s.push(e), N(this, c, H).call(this, t, [e]), () => {
      var o, a;
      const h = (o = i(this, d).get(t)) == null ? void 0 : o.findIndex((u) => u.id === e.id);
      h === void 0 || h < 0 || (a = i(this, d).get(t)) == null || a.splice(h, 1);
    };
  }
  /**
   * Acknowledges a given action. This will remove the action from its queue.
   */
  ack(t, e) {
    var h;
    const s = i(this, p).get(t.id);
    if (!s)
      if (i(this, f)) {
        i(this, f).call(this, {
          errorType: "NO_ACTIVE_ACTION_FOUND",
          action: t,
          ackSource: e
        });
        return;
      } else
        throw new Error(
          `No active action found. (${t.type}, ${t.targetWindowType}, ${t.id} | ${e.windowType})`
        );
    s.ack(), i(this, p).delete(t.id), N(this, c, x).call(this, t), N(this, c, W).call(this, t), (h = i(this, C)) == null || h.call(this, t, e);
  }
}
l = new WeakMap(), d = new WeakMap(), p = new WeakMap(), C = new WeakMap(), E = new WeakMap(), f = new WeakMap(), I = new WeakMap(), O = new WeakMap(), m = new WeakMap(), c = new WeakSet(), /**
 * Removes an action from its queue. This can either be a remapped queue or the
 * queue indicated by an action's `targetWindowType`
 */
x = function(t) {
  const e = i(this, m).get(t.id);
  i(this, m).delete(t.id);
  const s = i(this, l).get(
    e != null ? e : t.targetWindowType
  );
  if (!s)
    if (i(this, f)) {
      i(this, f).call(this, {
        errorType: "NO_ACTIVE_ACTION_FOUND",
        action: t
      });
      return;
    } else
      throw new Error(
        `Unexpectedly did not find queue for action: ${JSON.stringify(t)}`
      );
  const h = s.findIndex((o) => o.id === t.id);
  h >= 0 && s.splice(h, 1);
}, /**
 * Flushes all pending actions for a given `targetWindowType` to the provided `targets`, or
 * to all registered targets for the given window type if no custom targets are provided
 */
H = function(t, e) {
  const s = i(this, l).get(t);
  if (!(s != null && s.length))
    return;
  const h = e != null ? e : i(this, d).get(t);
  if (!h)
    return;
  const o = i(this, O);
  for (const a of h) {
    let u = o.get(a.id);
    u || (u = /* @__PURE__ */ new Set(), o.set(a.id, u));
    const $ = s.filter(
      (g) => !(u != null && u.has(g.id))
    );
    for (const g of $)
      u.add(g.id);
    a.handleActions($);
  }
}, W = function(t) {
  for (const e of i(this, O).values())
    e.delete(t.id);
};
export {
  D as ACK_ACTION_CHANNEL,
  U as ActionBroadcaster,
  S as ActionWrapper,
  F as HANDLE_ACTION_CHANNEL,
  P as PROCESS_ACTION_CHANNEL,
  R as REGISTER_WINDOW_CHANNEL
};
